import React, { useState } from 'react';

export interface RidesSearchCtx {
    ridesSearchResults: Array<string>;
    setRidesSearchResults: (rideIds: Array<string>) => void;
    emptySearchResults: boolean;
    setEmptySearchResults: (val: boolean) => void;
}

export const RidesSearchContext = React.createContext<RidesSearchCtx | null>(null);

export function RidesSearchContextProvider(props: { children: React.ReactNode }) {
    const [ridesSearchResults, setRidesSearchResults] = useState<Array<string>>([]);
    const [emptySearchResults, setEmptySearchResults] = useState<boolean>(false);

    return (
        <RidesSearchContext.Provider
            value={{ ridesSearchResults, setRidesSearchResults, emptySearchResults, setEmptySearchResults }}
        >
            {props.children}
        </RidesSearchContext.Provider>
    );
}

class OutsideContextError extends Error {}

export function useRidesSearchContext() {
    const context = React.useContext(RidesSearchContext);
    if (!context) {
        throw new OutsideContextError('useRideSearchContext must be used within a RidesSearchContextProvider');
    }
    return context;
}
